/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { Box, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";

interface RecommendedBadgeProps {
  show?: boolean;
}

export function RecommendedBadge({
  show = true,
}: RecommendedBadgeProps): JSX.Element {
  const { t } = useTranslation();

  if (!show) return <></>;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "-6px",
        right: "8px",
        backgroundColor: "success.600",
        color: "white",
        borderRadius: "8px",
        padding: "1px 6px",
        fontSize: "0.625rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        zIndex: 1,
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          color: "white",
          fontWeight: "bold",
          fontSize: "0.5rem",
        }}
      >
        {t("recommendedBadge.recommended")}
      </Typography>
    </Box>
  );
}
